import { http } from '../axios';
import { libraryManagedConfig } from '../../config';

export const deleteProductFromProductGroup = ({
    productGroupId,
    productId
}: {
    productGroupId: string;
    productId: string;
}) => {
    return http
        .put(
            libraryManagedConfig().endpointProductGroupBulk,
            { productIds: [productId] },
            {
                pathParams: {
                    productGroupId,
                    kind: 'ids',
                    action: 'remove'
                }
            }
        )
        .then(res => res.data);
};
